import { AppRouteProps } from "@bsm/component";
import React from "react";
import { InvoiceCreateRoute } from "./views/create/InvoiceCreateRoute";
import { InvoiceCreateManuallyRoute } from "./views/create-manual/InvoiceCreateManuallyRoute";
import { InvoiceListViewerRoutes } from "./views/viewer/InvoiceListViewerRoutes";

const InvoiceListContainer = React.lazy(() => import('./containers/InvoiceListContainer'));

export const InvoiceListRoutes: Array<AppRouteProps> = [
    {
        path: 'invoice',
        title: 'Bsm.Invoice.List.Title',
        element: <InvoiceListContainer />,
        roles: ['INVOICE'],
        children: [
            ...InvoiceCreateRoute,
            ...InvoiceCreateManuallyRoute,
            ...InvoiceListViewerRoutes
        ]
    }
] 